<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <div v-if="errorMessage" class="alert alert-danger" style="color: red;">
      {{ errorMessage }}
    </div>

    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <!-- Header -->
            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
              <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                User Management Information
              </h4>
            </div>

            <div class="row">
              <!-- Name -->
              <div class="col-md-4 col-12">
                <b-form-group label="Name:" label-for="first_name" label-class="font-weight-bold">
                  <b-form-input id="first_name" placeholder="Enter name":state="firstNameState" v-model="first_name" required />
                </b-form-group>
              </div>

              <!-- Email -->
              <div class="col-md-4 col-12">
                <b-form-group label="Email:" label-for="email" label-class="font-weight-bold">
                  <b-form-input id="email" placeholder="Enter email":state="emailState" type="email" v-model="email" required />
                </b-form-group>
              </div>

              <!-- Password -->
              <div class="col-md-4 col-12">
                <b-form-group label="Password:" label-for="password" label-class="font-weight-bold">
                  <b-form-input type="password" id="password" placeholder="Enter password":state="passwordState" v-model="password" required />
                </b-form-group>
              </div>

              <!-- Description -->
              <div class="col-md-4 col-12">
                <b-form-group label="Description:" label-for="description" label-class="font-weight-bold">
                  <b-form-input id="description" placeholder="Enter description":state="descriptionState" v-model="description" required />
                </b-form-group>
              </div>

              <!-- Phone -->
              <div class="col-md-4 col-12">
                <b-form-group label="Phone Number:" label-for="phone_number" label-class="font-weight-bold">
                  <b-form-input id="phone_number" placeholder="Enter phone number" :state="phoneState" v-model="phone_number" required />
                </b-form-group>
              </div>

              <!-- Address -->
              <div class="col-md-4 col-12">
                <b-form-group label="Address:" label-for="street_address" label-class="font-weight-bold">
                  <b-form-input id="street_address" placeholder="Enter Address" :state="addressState" v-model="street_address" required />
                </b-form-group>
              </div>

              <!-- Country -->
              <div class="col-md-4 col-12">
                <b-form-group label="Country:" label-for="country" label-class="font-weight-bold">
                  <v-select
                    id="country"
                    v-model="selectedCountry"
                    :options="countryOptions"
                    label="name"
                    track-by="isoCode"
                    placeholder="Select country"
                    :clearable="true"
                    :filterable="true"
                  />
                </b-form-group>
              </div>

              <!-- City -->
              <div class="col-md-4 col-12">
                <b-form-group label="City:" label-for="city" label-class="font-weight-bold">
                  <v-select
                    id="city"
                    v-model="selectedCity"
                    :options="cityOptions"
                    label="name"
                    track-by="id"
                    placeholder="Select city"
                    :clearable="true"
                    :filterable="true"
                    :disabled="!selectedCountry || !cityOptions.length"
                  />
                  <b-form-invalid-feedback v-if="selectedCountry && !cityOptions.length" class="d-block">
                    No cities available for the selected country.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <!-- State -->
              <div class="col-md-4 col-12">
                <b-form-group label="State:" label-for="state" label-class="font-weight-bold">
                  <b-form-input id="state" placeholder="Enter state" :state="stateState" v-model="state" required />
                </b-form-group>
              </div>

              <!-- Profile Picture -->
              <div class="col-md-4 col-12">
                <b-form-group label="Profile Picture:" label-for="image" label-class="font-weight-bold">
                  <div class="border rounded p-3 text-center"
                       style="cursor: pointer; background: #f9f9f9;"
                       @drop.prevent="onImageDrop"
                       @dragover.prevent
                       @click="$refs.profileInput.click()">
                    <div v-if="!imagePreview">
                      <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                      <p class="mb-0">Drag & Drop or Click to Upload</p>
                    </div>
                    <div v-else>
                      <img :src="imagePreview" alt="Preview" class="img-thumbnail" style="max-height: 120px;" />
                    </div>
                    <input ref="profileInput" type="file" accept="image/png, image/jpeg"
                           class="d-none" @change="onProfilePictureChange" />
                  </div>
                  <small class="text-muted">Only JPG/PNG, Max size: 2MB</small>
                  <b-form-invalid-feedback v-if="profileError" class="d-block text-danger">
                    {{ profileError }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else class="mb-8 mr-8" variant="primary" small />
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BForm, BFormGroup,
  BFormInput, BFormSelect, BSpinner, BFormInvalidFeedback
} from "bootstrap-vue";
import axios from "../../../axios";
import MultiSelect from "primevue/multiselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Country, City } from "country-state-city";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      description: "",
      first_name: "",
      email: "",
      phone_number: "",
      country: "",
      city: "",
      state: "",
      street_address: "",
      selectedRole:"manager",
      selectedModules: [],
      password: "",
      image: "",
      imagePreview: null,
      profileError: "",
      successMessage: "",
      errorMessage: "",
    selectedCountry: null,
    selectedCity: null,
    countryOptions: [],
    cityOptions: [],
    };
  },
  components: {
    BRow, BCol, BCard, BButton, BForm, BFormGroup,
  BFormInput, BFormSelect, BSpinner, BFormInvalidFeedback, MultiSelect, vSelect,
  },
  created() {
    this.countryOptions = Country.getAllCountries().map(({ name, isoCode }) => ({
      name,
      isoCode,
    }));
  },
  watch: {
    selectedCountry(newVal) {
      if (!newVal) {
        this.country = "";
        this.city = "";
        this.cityOptions = [];
        this.selectedCity = null;
        return;
      }
      this.country = newVal.name;
      this.selectedCity = null;
      this.city = "";
      this.cityOptions = City.getCitiesOfCountry(newVal.isoCode).map(({ name, countryCode, stateCode }) => ({
        name,
        id: `${countryCode}-${stateCode || "NA"}-${name}`,
      }));
    },
    selectedCity(newVal) {
      this.city = newVal ? newVal.name : "";
    },
  },
    computed:{
      firstNameState() { return this.validateField(this.first_name); },
      emailState() { return this.validateField(this.email, "email"); },
      passwordState() { return this.validateField(this.password); },
      descriptionState() { return this.validateField(this.description); },
      phoneState() { return this.validateField(this.phone_number, "number"); },
      addressState() { return this.validateField(this.street_address); },
      cityState() { return this.validateField(this.city); },
      stateState() { return this.validateField(this.state); },
      countryState() { return this.validateField(this.country); },
  },
  methods: {
    validateField(value, type = "text") {
          if (value === null || value === undefined || value === "") return null;

          if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
          }
          if (type === "number") {
            const regex = /^\+?[0-9 ]+$/;
            return regex.test(value.toString().trim());
          }
          return value.toString().trim().length > 0;
        },
    addUser() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("first_name", this.first_name);
      formData.append("email", this.email);
      formData.append("password", this.password);
      formData.append("description", this.description);
      formData.append("phone_number", this.phone_number);
      formData.append("country", this.country);
      formData.append("city", this.city);
      formData.append("state", this.state);
      formData.append("street_address", this.street_address);
      formData.append("type", this.selectedRole);

      if (this.image instanceof File) {
        formData.append("image", this.image);
      }

      axios.post("registerManagementUser", formData)
        .then(() => {
          this.$bvToast.toast("User added successfully!", {
            title: "Success", variant: "primary", solid: true,
            appendToast: true, toaster: "b-toaster-top-right", autoHideDelay: 5000,
          });
          this.isLoading = false;
          this.resetForm();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$bvToast.toast(
            (error.response?.data?.message?.email?.[0]) || "An error occurred. Please try again.",
            { title: "Error", variant: "danger", solid: true, appendToast: true,
              toaster: "b-toaster-top-right", autoHideDelay: 5000 }
          );
        });
    },

    onProfilePictureChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (!["image/jpeg", "image/png"].includes(file.type)) {
        this.profileError = "Only JPG/PNG allowed."; return;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.profileError = "Max size is 2MB."; return;
      }

      this.image = file;
      this.imagePreview = URL.createObjectURL(file);
      this.profileError = "";
    },

    onImageDrop(e) {
      const file = e.dataTransfer.files[0];
      this.onProfilePictureChange({ target: { files: [file] } });
    },

    resetForm() {
      this.first_name = "";
      this.email = "";
      this.password = "";
      this.description = "";
      this.phone_number = "";
      this.country = "";
      this.city = "";
      this.state = "";
      this.street_address = "";
      this.image = "";
      this.imagePreview = null;
      this.profileError = "";
      this.selectedCountry = null;
      this.selectedCity = null;
      this.cityOptions = [];
    },
  },
};
</script>

<style>
.fixed-width {
  width: 100%;
  border-radius: 6px;
}
</style>
